export default {
  business_types: (state) => state.business_types,
};
